module.exports = __webpack_public_path__ + "img/HYUNDAI.a232bfa1.svg";